import AnimationClip from '../AnimationClip';
import { Tween } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import ElementComponent from '../../../Component/UI/Element';
import ColorFilter from '../../../Component/ColorFilter';
import Point from '../../../Utility/Point';
import TransformComponent from '../../../Component/Transform';
import SpriteComponent from 'Component/Render/Sprite';
import Sprite from 'Prototype/Sprite';
import ShadowComponent from 'Component/UI/ShadowComponent';

type Meta = {
    scale: Point;
    forceNoShadow?: boolean;
    [key: string]: any;
};

export class ButtonRelease extends AnimationClip {
    public *execute(gameObject: GameObject, meta?: Meta): IterableIterator<number> {
        const shadowComponent = gameObject.getComponent(ShadowComponent);

        if (!meta.forceNoShadow && shadowComponent?.shadow) {
            yield* this.shadowAnimation(shadowComponent.shadow);
        } else {
            yield* this.colorScaleAnimation(gameObject, meta);
        }
    }
    protected getScaleTween(gameObject: GameObject, scale: Point): Tween {
        const component: TransformComponent | ElementComponent = gameObject.hasComponent(ElementComponent)
            ? gameObject.getComponent(ElementComponent)
            : gameObject.getComponent(TransformComponent);

        const scaleTween: Tween = this.getTween(component.scale);
        scaleTween.to({ x: scale.x, y: scale.y }, 100);
        return scaleTween;
    }

    private *shadowAnimation(shadow: Sprite) {
        const shadowSprite = shadow.getComponent(SpriteComponent);
        const tween = this.getTween(shadowSprite).to({ alpha: 0 }, 100);
        yield* this.startTween(tween);
    }

    private *colorScaleAnimation(gameObject: GameObject, meta?: Meta) {
        // "Remove" the brightness.
        const colorFilter = gameObject.getComponent(ColorFilter);
        if (colorFilter) {
            const colorTween: Tween = this.getTween(colorFilter);
            colorTween.to({ brightness: 1 }, 100).start(this.elapsedTime);
        }

        const scale: Point = new Point(meta.scale.x, meta.scale.y);
        const scaleTween = this.getScaleTween(gameObject, scale);

        yield* this.startTween(scaleTween);
    }
}
